import { Component } from '@angular/core';

@Component({
  selector: 'app-section-ext',
  templateUrl: './section-extended.component.html',
  styleUrls: ['./section.component.scss'],
})
export class SectionExtComponent { }
